var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgKupony = function SvgKupony(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,5.4c0,0.3,0.4,0.6,0.8,0.5s0.6-0.5,0.6-0.8C10,4.7,9.6,4.5,9.2,4.6C8.8,4.7,8.6,5,8.7,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,15.2C20,4.1,20.3,4.8,20.2,4.8c-0.4-0.9-1.2-1.6-2.1-2C18,2.8,10.3,1,10,0.9C9.4,0.7,8.4,0.8,7.8,1.4 L1.2,7.5C0.4,8.2,0,9.1,0,10.2V21c0,1.3,1,2.3,2.3,2.3h14.1c1.3,0,2.3-1,2.3-2.3v-1l3.9-1.7C23.8,17.7,24.3,16.4,23.8,15.2 L23.8,15.2z M16.4,21.8H2.3c-0.5,0-0.9-0.4-0.9-0.9V10.2c0-0.6,0.3-1.2,0.7-1.6c5.7-5.2,2.2-2,6.6-6.1C9,2.2,9.3,2.1,9.6,2.2 c0.3,0.1-0.2-0.3,7,6.3c0.5,0.4,0.7,1,0.7,1.6v10.8C17.3,21.4,16.9,21.8,16.4,21.8L16.4,21.8z M22.1,16.9l-3.4,1.4v-8.2 c0-1-0.4-2-1.2-2.7L12.6,3l5.1,1.2c0.6,0.2,1,0.6,1.2,1.2c3.8,11.1,3.6,10.4,3.6,10.4C22.7,16.2,22.5,16.7,22.1,16.9L22.1,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,9.5c-0.4-0.2-0.8,0-0.9,0.4L7,18c-0.2,0.5,0.1,1,0.6,1c0.3,0,0.5-0.2,0.6-0.4l3.4-8.2 C11.9,10,11.7,9.6,11.3,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,11.5C8,10.2,7.1,9,5.8,9s-2.2,1.1-2.2,2.5s1,2.5,2.2,2.5S8,12.9,8,11.5L8,11.5z M5.8,12.6 c-0.4,0-0.8-0.5-0.8-1.1s0.4-1.1,0.8-1.1s0.8,0.5,0.8,1.1C6.6,12.1,6.3,12.6,5.8,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,14.6c-1.2,0-2.2,1.1-2.2,2.5s1,2.5,2.2,2.5s2.2-1.1,2.2-2.5S14.1,14.6,12.9,14.6z M12.9,18.1 c-0.4,0-0.8-0.5-0.8-1.1s0.4-1.1,0.8-1.1s0.8,0.5,0.8,1.1S13.4,18.1,12.9,18.1z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKupony, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kupony.57ae9d47.svg";
export { ForwardRef as ReactComponent };